///<reference path="../../../node_modules/@angular/router/src/url_tree.d.ts"/>
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {
  ActivatedRoute, NavigationEnd, Route, Router
} from '@angular/router';
import {AuthService} from '../core/auth.service';
import {User, UserType, UserSampleSetups} from '../../models/user';
import {UserService} from '../services/user.service';
import {Advertiser, CompanyStatus} from '../../models/common';
import {Subscription} from 'rxjs/Subscription';
import {
  EventTrackerService, Page, TargetType,
  UserActionType
} from '../services/event-tracker/event-tracker.service';
import {PopperContent} from '../../../node_modules/ngx-popper';
import {Location, PlatformLocation} from '@angular/common';
import {ModalService} from '../services/modal/modal.service';
import {AchooPopupComponent} from '../core/achoo-popup/achoo-popup.component';
import {PlatformSettings} from '../../models/platform-settings/platform-settings';
import {CommonConstant, defaultPlatformSettings} from '../app.constants';
import {CacheService} from '../services/cache/cache.service';
import {DiscoverService} from '../services/discover/discover.service';
import {AppSettings} from '../utils/app-settings';
import {PdfExportService} from '../services/export-pdf/pdf-export.service';
import { InfluencerGroupsService } from './influencer-groups/influencer-groups.service';
import { timer } from 'rxjs/observable/timer';
import { concatMap, filter } from 'rxjs/operators';
import { ObjectUtils } from '../utils/object.utils';
declare var hbspt: any;
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})

export class MainComponent implements OnInit, OnDestroy {
    @ViewChild('AlertPdfDownloadPending') alertPdfDownloadPending: AchooPopupComponent;
    @ViewChild('AlertPdfSuccess') alertPdfSuccess: AchooPopupComponent;
    @ViewChild('AlertPdfError') alertPdfError: AchooPopupComponent;
    @ViewChild('InvalidActionByLevelWarning') invalidActionByLevelWarning: AchooPopupComponent;
    @ViewChild('SupportForm') supportForm: AchooPopupComponent;

    private user: User;
    public campaignRouterLink: string[];
    public companyList: any[];
    public currentCompanyId: number;
    private companyIdSubjectSubscription: Subscription;
    private checkingAccountLevelSubscription: Subscription;
    private reportExportingSubscription: Subscription;
    private reportExportingErrorSubscription: Subscription;
    private startPremiumTrialSubscription: Subscription;
    private supportContactSubscription: Subscription;
    public showFadedBg: boolean;
    @ViewChild('changeAccountPopper')
    public changeAccountPopper: PopperContent;
    public platformSettings: PlatformSettings;

    // warning message for user when executing an action is not valid by their levels
    public invalidLevelMsg;
    // define flag to prevent send duplicate MP event
    private haveSentViewEventTracking = false;
    public invalidActionByLevelWarningRef;
    private pollingPendingInfluencerSubscription: Subscription;
    public showPendingInfluencerIndicator = false;
    public sampleSetupData: Array<UserSampleSetups> = [];
    public showAccountList = false;

    public activatedInfluencersData;
    private _activatedInfluencersSubscription: Subscription;

    constructor(private auth: AuthService,
                private router: Router,
                private location: Location,
                private platformLocation: PlatformLocation,
                private activatedRoute: ActivatedRoute,
                private userService: UserService,
                private eventTracker: EventTrackerService,
                private modalService: ModalService,
                private cacheService: CacheService,
                private discoverService: DiscoverService,
                private pdfExportService: PdfExportService,
                private influenderGroupsService: InfluencerGroupsService
                ) {
      this.user = new User();
      this.userService.platformSettings.subscribe(setting => {
        this.platformSettings = setting;
      });

      platformLocation.onPopState(() => {
        this.cacheService.disableCacheRemoving();
      });

      router.routeReuseStrategy.shouldReuseRoute = () => {
        return false;
      };

      router.events.forEach((event) => {
        if (event instanceof NavigationEnd && this.currentCompanyId) {
          if (this.auth.isAuth() && event.url.indexOf('activeAccount=') < 0 && event.urlAfterRedirects !== '/404') {
            this.updateRouteUrl(event.url, this.currentCompanyId, this.activatedRoute.snapshot.queryParams);
          }
          if (event.url.indexOf('/discover') >= 0) {
            this.discoverService.activeDiscoverPage();
            this.scrollToLastPosition();
            this.discoverService.onLeaveDiscoverPage(false);
          } else {
            this.discoverService.inactiveDiscoverPage();
            this.discoverService.onLeaveDiscoverPage(true);
          }
          if (event.url.indexOf('influencer/') < 0 && this.cacheService.shouldRemoveCachedData) {
            this.cacheService.clearAll();
          }
          const path = event.url.split('?')[0];
          if (!this.haveSentViewEventTracking) {
            this.trackUserNavigation(activatedRoute.snapshot.routeConfig.children, path.substring(1));
            this.haveSentViewEventTracking = true;
          }
        }
      });
    }

    ngOnInit() {
        this.user = this.auth.getUser();
        this.triggerSignUpEvent();
        if (this.user.type === UserType.INFLUENCER) {
            this.campaignRouterLink = ['/framed/influencerCampaigns'];
        } else {
            this.campaignRouterLink = ['/campaigns'];
        }

        this.activatedRoute.queryParams.subscribe(params => {
          if (params['activeAccount'] && Number(params['activeAccount']) !== this.userService.getCompanyId()) {
            this.userService.setCompanyId(Number(params['activeAccount']), true);
          }
        });

        if (this.user.type === UserType.ADMIN || this.user.type === UserType.AGENCY) {
          this.companyList = this.userService.getAdvertiserList().filter(x => this.canShowAdvertiser(x));
          this.companyIdSubjectSubscription = this.userService.companyId.subscribe((id) => {
            this.currentCompanyId = id;
            // update active account queryParams
            const queryParams = this.activatedRoute.snapshot.queryParams;
            this.updateRouteUrl(this.router.url.split('?')[0], id, queryParams);
          });
        }

        if (this.user.type === UserType.ADVERTISER) {
          this.currentCompanyId = this.userService.getCompanyId();
        }

        this._activatedInfluencersSubscription = this.userService.activeInfluencers$.subscribe(data => this.activatedInfluencersData = data);

        // list invalid action by level event
        this.checkingAccountLevelSubscription = this.userService.invalidActionLevelObject.subscribe(res => {
          if (res) {
            this.invalidLevelMsg = res.message;
            this.invalidActionByLevelWarningRef = this.modalService.openInCenter(this.invalidActionByLevelWarning, () => {
              this.tracWallNotificationUsage(true, TargetType.BACKDROP);
              this.invalidLevelMsg = undefined;
            }, 'invalid-level-modal');
            this.userService.resetInvalidActionObject();
          }
        });
        this.haveSentViewEventTracking = false;
        this.cacheService.enableCacheRemoving();
        this.pollPendingInfluecer(this.currentCompanyId);
        this.exposeSampleDataSetupFunctions();

        // handling contact support
        this.supportContactSubscription = this.userService.contactSupportRequested.subscribe({
          next: () => this.closePopupAndOpenIntercom()
        });
    }

    ngOnDestroy() {
      this.discoverService.disableCachingScrollPosition();
      if (this.companyIdSubjectSubscription) {
        this.companyIdSubjectSubscription.unsubscribe();
      }
      if (this.checkingAccountLevelSubscription) {
        this.checkingAccountLevelSubscription.unsubscribe();
      }
      if (this.reportExportingSubscription) {
        this.reportExportingSubscription.unsubscribe();
      }
      if (this.reportExportingErrorSubscription) {
        this.reportExportingErrorSubscription.unsubscribe();
      }
      if (this.pollingPendingInfluencerSubscription) {
        this.pollingPendingInfluencerSubscription.unsubscribe();
      }
      if (this.startPremiumTrialSubscription) {
        this.startPremiumTrialSubscription.unsubscribe();
      }
      if (this.supportContactSubscription) {
        this.supportContactSubscription.unsubscribe();
      }
      if (this._activatedInfluencersSubscription) {
        this._activatedInfluencersSubscription.unsubscribe();
      }
    }

  scrollToLastPosition() {
    if (this.cacheService.has(CommonConstant.DISCOVER_SCROLL_TOP)) {
      this.cacheService.get(CommonConstant.DISCOVER_SCROLL_TOP).subscribe((pos) => {
        if ((document.documentElement.scrollHeight * 0.9) > pos) {
          // deactive infinitive loading while scrolling to last position
          this.discoverService.onScrollToPreviousPosition(true);
          // active infinitive loading after 1s
          setTimeout(() => {
            window.scrollTo(0, pos);
            this.discoverService.onScrollToPreviousPosition(false);
            this.discoverService.enableCachingScrollPosition();
          }, 1000);
        }
      });
    } else {
      this.discoverService.enableCachingScrollPosition();
    }
  }

    toggleMobileMenu() {
      document.getElementById('mobile-menu').classList.toggle('show');
    }

    logout() {

      this.auth.logout();

      return false;
    }

    hideAccountList() {
      this.showAccountList = false;
    }

    openAccountList() {
      this.showAccountList = true;
    }

    private updateRouteUrl(pathUrl, companyId, params = {}) {
      const queryParams = Object.assign({}, params, {activeAccount: companyId});
      const baseRouteUrl = pathUrl.split('?')[0];
      const url = this.router.createUrlTree([baseRouteUrl], {
        queryParams: queryParams
      }).toString();

      this.location.replaceState(url);
    }

    public changeAccount(companyId) {
      this.userService.setCompanyId(companyId, true, true);
      if (this.pollingPendingInfluencerSubscription) {
        this.pollingPendingInfluencerSubscription.unsubscribe();
      }
      this.pollPendingInfluecer(this.currentCompanyId);
    }

    public openIntercom() {
      this.modalService.openInCenter(this.supportForm);
      setTimeout(() => {
        const hubspotFormContainer = document.querySelector('.support-hubspot-form');
        if (hubspotFormContainer) {
          const hubspotFormIframe = hubspotFormContainer.querySelector('.hs-form-iframe');
          if (!hubspotFormIframe) {
            hbspt.forms.create({
              portalId: '8031552',
              formId: AppSettings.mmiHubSpotFormId(),
              target: '.support-hubspot-form'
            });
          }
        }
      }, 200);
    }

    public popperOnShown(e) {
      this.showFadedBg = true;
    }

    public popperOnHidden(e) {
      this.showFadedBg = false;
      this.changeAccountPopper.hide();
    }

    get platformBgColor() {
      return this.platformSettings ? this.platformSettings.platformBgColor : defaultPlatformSettings.platformBgColor;
    }

    get logoImage() {
      return this.userService.leftSidebarLogoImage;
    }

    get hasCreditBasedBilling() {
      return this.userService.hasCreditBaseBilling();
    }

    get isDisableInboxPage() {
      return this.userService.isFreeUser() || AppSettings.isDisableChat();
    }

    get needToUpgradeAccount() {
      return !this.userService.isFreeUser() || this.userService.hasStartedTrial();
    }

    get faqLink() {
      return AppSettings.faqLink();
    }

    get isSsoUser() {
      return this.userService.isSsoUser;
    }

    closeAlertPopup() {
      this.modalService.close();
    }

    closeWallNotification(targetType?) {
      this.tracWallNotificationUsage(false, targetType);
      if (this.invalidActionByLevelWarningRef) {
        this.modalService.closeSinglePopup(this.invalidActionByLevelWarningRef);
      }
    }

    closePopupAndOpenIntercom() {
      this.modalService.close();
      this.openIntercom();
    }

    upgradeAccount(evt) {
      this.closeWallNotification();
      return this.router.navigate(['account-settings', 'billing']);
    }

    contactSupport() {
      this.closeWallNotification();
      this.openIntercom();
    }

    trackByFn(index, item) {
      return index;
    }

    private trackUserNavigation(childRoutes: Route[], urlNavigation: string) {
      const activatedRoute = childRoutes.find((route) => route.path === urlNavigation);

      if (activatedRoute && activatedRoute.data && activatedRoute.data.segmentItem) {
        this.eventTracker.trackUserAction(UserActionType.VIEW, activatedRoute.data.segmentItem,
          undefined, undefined, undefined, {
            type: activatedRoute.data.segmentActivePage
          });
      }
    }

    private tracWallNotificationUsage(needSupport, targetType?) {
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.WALL_NOTIFICATION, {
        name: needSupport ? 'Support' : 'OK',
        type: targetType ? targetType : TargetType.BUTTON
      }, {
        action: UserActionType.TOGGLE
      });
    }

    private pollPendingInfluecer(companyId) {
      if (this.cacheService.has(`influencer_group_list_${companyId}`)) {
        this.cacheService.clear(`influencer_group_list_${companyId}`);
      }
      this.pollingPendingInfluencerSubscription = timer(0, AppSettings.getDefaultTimer())
        .pipe(
          filter(() => {
            // make sure not polling influncer if current account is inactive
            const ad = this.userService.getCurrentAdvertiser();
            return ad && !ad.inactive;
          }),
          concatMap(() => this.influenderGroupsService.getInfluencerGroups(companyId))
        ).subscribe((res) => {
          this.cacheService.set(`influencer_group_list_${companyId}`, res);
          const filteredPendingInfItem = res.filter(item => item.totalPendingInfluencers > 0);
          const isGroupPage = this.router.url.indexOf('groups') < 0;
          this.showPendingInfluencerIndicator = isGroupPage && filteredPendingInfItem && filteredPendingInfItem.length > 0;
        });
    }

    get userAvatar() {
      const userData = ObjectUtils.parseJSON(localStorage.getItem('user')) as User;
      return userData && userData.data && userData.data.image ? userData.data.image : CommonConstant.DEFAULT_USER_AVATAR;
    }

    private exposeSampleDataSetupFunctions() {
      window['sampleDataSetupFunctions'] = {
        loadSetups: (callback: (error, data) => void) => {
          this.loadSampleData(callback);
        },
        createSampleData: (sampleDataSetUpId: number, callback: (error, data) => void) => {
          this.createSampleData(sampleDataSetUpId, this.currentCompanyId, callback);
        }
      };
    }

    private loadSampleData(callback: (error, data) => void) {
      return this.userService.getSampleData().subscribe(res => {
        this.sampleSetupData = res;
        this.sendMixpanelEvent();
        callback(null, res);
      }, error => {
        callback(error, null);
      });
    }

    private createSampleData(sampleDataSetUpId: number, companyId: number, callback: (error, data) => void) {
      return this.userService.createSampleData(sampleDataSetUpId, companyId).subscribe(res => {
        const choosingSampleData = this.sampleSetupData.filter(item => item.id === sampleDataSetUpId)[0];
        this.sendMixpanelEvent(choosingSampleData);
        callback(null, res);
      }, error => {
        callback(error, null);
      });
    }

    private sendMixpanelEvent(targetData?: UserSampleSetups) {
      const target = targetData ? {id: targetData.id, name: targetData.label} : null;
      this.eventTracker.trackUserAction(UserActionType.ONBOARDING, null, target, {
        action: targetData ? UserActionType.CHOSE_DATA_SAMPLE : UserActionType.LOAD_DATA_SAMPLES
      }, undefined, null, null);
    }

  private triggerSignUpEvent() {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    if (queryParams.accessToken && queryParams.signup === 'true') {
      this.eventTracker.trackUserSignup(this.auth.getUser(), false);
      const normalizeQueryParams = {};
      Object.keys(queryParams).forEach(k => {
        if (k !== 'accessToken' && k !== 'signup') {
          Object.defineProperty(normalizeQueryParams, k, {
            value : queryParams[k]
          });
        }
      });
      return this.router.navigate([this.router.url.split('?')[0]], normalizeQueryParams);
    }
  }

  isEnableInfluencerReviewFeature() {
      return AppSettings.isEnableInfluencerReview();
  }

  private canShowAdvertiser(adv) {
    return adv.status !== CompanyStatus.BLOCKED && adv.status !== CompanyStatus.CHURNED;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/main.component.ts